<div class="facility-select" (click)="toggle($event)" [class.open]="open()" [@selectPulse]="selected">
    <fad i="building" class="icon"></fad>
    <div class="caption" *ngIf="selected" [@selectCaptionPulse]="selected">
        <div class="label" *ngIf="selected.organization">{{selected.organization.name}}</div>
        <div class="name d-flex align-items-center">
            <span class="mr-auto">{{selected.name}}</span>
            <span *ngIf="selected.facility?.state"
                  class="ml-2 small text-muted">
                {{ selected.facility.state }}
            </span>
        </div>
    </div>
    <fas i="chevron-down" class="chevron"></fas>
</div>
<div class="facility-select-options-wrapper" data-test-id="facility-select-options-wrapper">
    <div class="options card" (clickOutside)="close()" *ngIf="open()" [@popFromLeft]>
        <div class="section-head p-4 m-0" [@popFromLeftInner]>
            <h3 class="title text-primary" style="opacity: 1">Select Facility</h3>
        </div>
        <div class="form-group facility-select-input-wrapper">
            <input #facilitySearchInput
                   id="facility-search-input"
                   [ngModel]="facilitySearchString()"
                   (ngModelChange)="onFacilitySearchChange($event)"
                   type="text"
                   class="form-control"
                   placeholder="Search for facilities...">
        </div>
        <div class="options-inner">
            <ng-container *ngIf="flatList().length; else noMatch">
                <cdk-virtual-scroll-viewport [style.height.px]="viewportHeight()"
                                             class="virtual-scroll-viewport"
                                             [@popFromLeftInner]>
                    <div class="nav flex-column nav-pills">
                        <ng-container *cdkVirtualFor="let item of flatList()">
                            <!-- Inactive Header -->
                            <div *ngIf="item.type === 'inactive-header'" class="section-head m-0 p-3">
                                <h3 class="title">{{ item.headerText }}</h3>
                            </div>

                            <!-- Organization Header -->
                            <div *ngIf="item.type === 'header'" class="section-head m-0 p-3">
                                <h3 class="title">{{ item.headerText }}</h3>
                            </div>

                            <!-- Facility Item -->
                            <div *ngIf="item.type === 'facility'" class="d-flex align-items-center">
                                <div (click)="selectFacility(item.option)"
                                     [class.active]="selected?.name === item.option.name"
                                     [class.keyboard-selected]="item.option.keyboardSelected"
                                     [class.inactive]="item.option.facility?.is_inactive || adminView && item.option.facility?.is_suspended"
                                     class="nav-link flex-grow-1 cursor-pointer d-flex align-items-center">
                                    <span class="caption mr-auto">{{ item.option.name }}</span><div class="d-flex align-items-center">
                                        <span class="ml-2 small" *ngFor="let info of getAdditionalInfo(item.option.facility)">
                                            <fas *ngIf="info.icon; else infoText"
                                                 [i]="info.icon"
                                                 [ngbTooltip]="info.label"
                                                 class="text-{{info.colorClass}}">
                                            </fas>
                                            <ng-template #infoText>
                                                <span class="additional-info">{{info}}</span>
                                            </ng-template>
                                        </span>
                                    </div>
                                </div>
                                <ng-container *ngIf="adminView && item.option.organization">
                                    <div class="d-flex flex-column">
                                        <app-action-icon *ngIf="item.option.facility"
                                                         icon="eye"
                                                         size="sm"
                                                         routerLink="/system-settings/organizations/facilities/{{item.option.facility.id}}/"
                                                         (click)="close()">
                                        </app-action-icon>
                                        <app-action-icon *ngIf="item.option.facility"
                                                         icon="pencil"
                                                         size="sm"
                                                         routerLink="/system-settings/organizations/facilities/{{item.option.facility.id}}/edit"
                                                         (click)="close()">
                                        </app-action-icon>
                                        <app-action-icon *ngIf="!item.option.facility"
                                                         icon="pencil"
                                                         size="sm"
                                                         routerLink="/system-settings/organizations/{{item.option.organization.id}}"
                                                         (click)="close()">
                                        </app-action-icon>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                </cdk-virtual-scroll-viewport>
            </ng-container>
        </div>
        <app-tail class="tail" direction="left"></app-tail>
    </div>
</div>

<ng-template #noMatch>
    <div class="text-muted section-head m-0 p-4">No facilities match the search.</div>
</ng-template>
